import React from "react";

import img1 from "../img/Picnic at the park on a sunday afternoon&&[{caligo.densa(est)}]---Blending textures over AI generated images on Adobe Photoshop___2025-07[[3]].jpg"

export default function Machine_3_3() {
  return (
    <div className="panel-block">

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="3.3 · FRAGMENTS, TRANSMISSIONS, REALITY LEAKS"
        />
      </div>

      <div className="panel-container-right">
        <h2>3.3 · FRAGMENTS, TRANSMISSIONS, REALITY LEAKS</h2>

      <p>
    Short ruptures in the surface.
  </p>

  <p>
    Inscriptions.<br />
    Field notes.<br />
    Distortions of this reality<br />
    or others.
  </p>

  <p>
    Sometimes the Machine speaks.<br />
    Sometimes it misfires.<br />
    Sometimes it reveals what should have remained implicit.
  </p>

  <p>
    These texts do not explain the present.<br />
    They destabilize it.
  </p>
      </div>

    </div>
  );
}
